module.exports = __webpack_public_path__ + "img/c06_unitstartechshieldbearerchampion_Normal_ua.4b14eadb.webp";